import { ReactElement } from "react";
import { Link } from "react-router-dom";

export interface INavListItem {
  icon: ReactElement;
  text: string;
  selectedPage: string;
  handleSelectedChange: any;
  linkTo: string;
}

export default function NavListItem(props: INavListItem) {
  return (
    <Link to={props.linkTo}>
      <button
        type="button"
        onClick={() => {
          props.handleSelectedChange(props.text);
        }}
        className={`w-full flex items-center gap-5 px-5 py-4 rounded-lg  ${
          props.selectedPage === props.linkTo
            ? "bg-brij-Default"
            : "hover:bg-brij-MudDark"
        }`}
      >
        <div className="box-border w-[26px] h-[26px]">{props.icon}</div>
        <div
          className={props.selectedPage === props.linkTo ? "text-brij-Mud" : ""}
        >
          {props.text}
        </div>
      </button>
    </Link>
  );
}
